import { globalAny } from "../../utils/Utils";
import Image from "../Image/Image";
import SeeMore from "../../assets/Icons/See_more.svg";
import TouchableOpacity from "../TouchableOpacity/TouchableOpacity";
import { Props } from "./model";
import { StyledSeeMore, StyledSeeMoreText } from "./styled";

const SeeMoreComponent = ({ onPress, ...props }: Props) => {
	const size = props.isNarrow ? "2.33vw" : "3.33vw";

	return (
		<TouchableOpacity onPress={onPress} style={{ height: "100%" }}>
			<StyledSeeMore {...props}>
				<Image source={{ uri: SeeMore }} style={{ width: size, height: size }} />
				{/* @ts-ignore */}
				<StyledSeeMoreText isNarrow={props.isNarrow}>{globalAny.language.see_more}</StyledSeeMoreText>
			</StyledSeeMore>
		</TouchableOpacity>
	);
};

export default SeeMoreComponent;
